import { createContext } from 'react';
import { INotificationManager } from './types';

export const baseNotificationContextValue: INotificationManager = {
  errors: [],
  notice: undefined,
  setErrors: () => {},
  setNotice: () => {},
  errorString: undefined,
  clearAllNotifications: () => {},
};

export const createNewNotificationContext = () =>
  createContext<INotificationManager>(baseNotificationContextValue);
